<template>
  <a-flex vertical>
    <products-filter
      @filterCleaned="
        combineProductsBySizeStore.clearFilter();
        router.push({ query: {} });
      "
      style="width: 100%"
      search-placeholder="Поиск по наименованию, штрихкоду, артикулу"
      v-model:search="combineProductsBySizeStore.filters.searchPhrase"
      v-model:created-in-ozon="combineProductsBySizeStore.filters.createdInOzon"
      v-model:created-in-wb="combineProductsBySizeStore.filters.createdInWb"
      v-model:not-created-in-ozon="
        combineProductsBySizeStore.filters.notCreatedInOzon
      "
      v-model:not-created-in-wb="
        combineProductsBySizeStore.filters.notCreatedInWb
      "
      v-model:drag-list="combineProductsBySizeStore.dragList"
      v-model:column-for-init="combineProductsBySizeStore.columnsFiltered"
      v-model:table-name="combineProductsBySizeStore.columnsConfigName"
    />
  </a-flex>

  <a-card v-show="showNotify" class="notify">
    <a-flex align="center" justify="center" gap="small">
      <InfoCircleOutlined class="icon danger" />

      <a-typography-text type="danger">
        Нет категорий или товаров для которых ведется учет по размерам.
      </a-typography-text>
    </a-flex>
  </a-card>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useCombineProductsBySize } from "@/stores/product/combineProducts/combineProductsBySize/combine-products-by-size.store";
import { debounce } from "@/tools/debounce";
import ProductsFilter from "@/components/product/products/ProductsFilter.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { useCustomCategoriesStore } from "@/stores/customCategories/customCategories";
import { useRouter } from "vue-router";

const combineProductsBySizeStore = useCombineProductsBySize();
const customCategoryStore = useCustomCategoriesStore();
const router = useRouter();

const customCategories = computed(() =>
  customCategoryStore.customCategories.filter((category) => category.sizesOn),
);

const showNotify = computed(
  () =>
    (combineProductsBySizeStore.isLoadingDone &&
      !customCategories.value.length) ||
    (combineProductsBySizeStore.isLoadingDone &&
      !combineProductsBySizeStore.productsTableData.length),
);

watch(
  () => combineProductsBySizeStore.filters,
  debounce((value) => combineProductsBySizeStore.loadData(value), 500),
  { deep: true },
);
</script>

<style scoped lang="scss">
.wrapper {
  padding: 14px;
  border-radius: 10px;

  :deep(.ant-input-group-wrapper) {
    max-width: 580px;
  }

  :deep(.ant-badge) {
    margin-left: auto;
  }
}

.icon {
  font-size: 20px;
  line-height: 1;

  &.danger {
    color: var(--color-error);
  }
}

.notify {
  margin-top: -32px;
  z-index: -1;

  :deep(.ant-card-body) {
    padding-bottom: calc(var(--size-sm) * 1px);
  }
}
</style>
